export default "__VITE_ASSET__B6eH7S1e__"